import { LightBox } from '@kamernet/modules/Media/components/LightBox';

import { ListingDetailsContext } from '../../ListingDetailsContext';
import { SocialMediaShare } from '../SocialMediaShare';

export interface LightBoxWrapperProps {
  onClose: () => void;
}

export const LightboxWrapper = ({ onClose }: LightBoxWrapperProps) => {
  const { shareTargetURL, listingDetails } = ListingDetailsContext.useContext();

  return (
    <LightBox
      imageKeys={listingDetails.imageList}
      thumbnailImageKeys={listingDetails.thumbnailImageList}
      videoKeys={listingDetails.videoIdList}
      imgAltPrefix={listingDetails.computedStreetName}
      shareButtonSlot={
        <SocialMediaShare isBlackBackground targetURL={shareTargetURL} />
      }
      onClose={onClose}
    />
  );
};
